import { Box } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { Skeleton } from "@chakra-ui/react";
import { Empty } from "antd";
import ItemCotacao from "./components/ItemCotacao";
import { showConfirm } from "infra/helpers/alerta";
import PrimaryButton from "components/Button/PrimaryButton";
import ModalCotacao from "./components/ModalCotacao";
import ModalDetalhesCotacao from "./components/ModalDetalhesCotacao";
import { useListarCotacao } from "core/features/orcamento/hooks/useListarCotacaoes";
import useDeleteOrcamentoCotacao from "core/features/orcamento/hooks/useDeleteOrcamentoCotacao";
import { showSuccess } from "infra/helpers/alerta";
import { useLoading } from "components/GlobalLoading";
import { useBreadcrumb } from "core/features/breadcrumbs";
import ModalAprovarItems from "./components/ModalAprovarItems";

export default function Cotacoes({ id }: { id: string }) {
  useBreadcrumb([
    { name: "Administração", url: "/administracao" },
    { name: "Orçamento", url: "/administracao/orcamento" },
    {
      name: "Cotação",
    },
  ]);
  const [editId, setEditId] = useState<string | undefined>();
  const [viewCotacaoId, setViewCotacaoId] = useState<string | undefined>();
  const [approveId, setApproveId] = useState<string | undefined>();

  const [openModal, setOpenModal] = useState(false);
  const [openModalDetalhesCotacao, setOpenModalDetalhesCotacao] =
    useState(false);

  const {
    data,
    isLoading,
    refetch: refetchCotacao,
    isFetching,
  } = useListarCotacao(id);

  const { mutate: handleDeleteCotacao, isLoading: isLoadingDelete } =
    useDeleteOrcamentoCotacao(id);

  useEffect(() => {
    if (editId) {
      setOpenModal(true);
    }
  }, [editId]);

  useEffect(() => {
    if (!openModal) {
      setEditId(undefined);
    }
  }, [openModal]);

  useEffect(() => {
    if (viewCotacaoId) {
      setOpenModalDetalhesCotacao(true);
    }
  }, [viewCotacaoId]);

  useEffect(() => {
    if (!openModalDetalhesCotacao) {
      setViewCotacaoId(undefined);
    }
  }, [openModalDetalhesCotacao]);

  const handleDelete = async (id: string) => {
    const { isConfirmed } = await showConfirm();

    if (isConfirmed) {
      handleDeleteCotacao(id, {
        onSuccess: async () => {
          refetchCotacao();
          await showSuccess();
        },
      });
    }
  };

  const _isLoading = isLoading || isLoadingDelete || isFetching;

  useLoading(_isLoading);
  return (
    <>
      <Box>
        <PrimaryButton onClick={() => setOpenModal(true)} mb={6}>
          Nova cotação
        </PrimaryButton>
        {isLoading ? (
          <>
            <Skeleton w="100%" h="90px" />
            <Skeleton w="100%" h="90px" />
            <Skeleton w="100%" h="90px" />
            <Skeleton w="100%" h="90px" />
          </>
        ) : null}

        {!isLoading && !data?.length ? (
          <Empty description="Sem itens." />
        ) : null}

        {data?.map((item, index) => (
          <ItemCotacao
            key={item.id}
            item={item}
            handleDelete={handleDelete}
            indexItem={index}
            onEdit={setEditId}
            onView={setViewCotacaoId}
            onApprove={setApproveId}
          />
        ))}
      </Box>

      {openModal ? (
        <ModalCotacao
          isOpenModal={openModal}
          onClose={() => setOpenModal(false)}
          cotacaoId={editId}
          orcamentoId={id}
          refetchCotacao={refetchCotacao}
        />
      ) : null}

      <ModalDetalhesCotacao
        isOpenModal={openModalDetalhesCotacao}
        onClose={() => setOpenModalDetalhesCotacao(false)}
        cotacaoId={viewCotacaoId}
        orcamentoId={id}
      />

      {approveId ? (
        <ModalAprovarItems
          isOpenModal={!!approveId}
          onClose={() => setApproveId(undefined)}
          cotacaoId={approveId}
          orcamentoId={id}
          refetch={refetchCotacao}
        />
      ) : null}
    </>
  );
}
